import {Component, OnInit} from "@angular/core";
import {VersionInfo} from "src/environments/version-info.model";
import {Observable} from "rxjs";
import {EndpointsProvider} from "../../endpoints/endpoint-provider.service";
import {environment} from "../../../../environments/environment";

@Component({
    selector: 'app-version',
    templateUrl: './app-version.template.html',
    standalone: false
})
export class AppVersionComponent implements OnInit {

	webAppInfo: VersionInfo;
	serverInfo$: Observable<VersionInfo>;

	constructor(private endpoints: EndpointsProvider) {
	}

	ngOnInit(): void {
		this.webAppInfo = environment.versionInfo;
		this.serverInfo$ = this.endpoints.appSettings.getVersionInfo();
	}

}


